import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../Styles/Blog.css';
import { BotanicalCorner } from './BotanicalSVG';

const formatDate = val => {
  if (!val) return null;
  const d = val?.toDate ? val.toDate() : new Date(val);
  if (isNaN(d)) return null;
  return {
    display: d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }),
    iso: d.toISOString().split('T')[0],
  };
};

const readMins = content => {
  if (!content) return null;
  const words = content.replace(/<[^>]+>/g, ' ').split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.ceil(words / 200));
};

const BlogCard = ({ post, featured = false }) => {
  const [imageFailed, setImageFailed] = useState(false);
  const date  = formatDate(post.createdAt || post.publishedAt);
  const slug  = post.slug || post.id;
  const mins  = readMins(post.content);

  return (
    <Link
      to={`/blog/${slug}`}
      className={`blog-card${featured ? ' blog-card-featured' : ''}`}
      style={{ position: 'relative' }}
    >
      <BotanicalCorner
        style={{ position: 'absolute', top: 5, right: 5, opacity: 0.12, width: 40, height: 40, zIndex: 0 }}
      />

      {post.thumbnail && !imageFailed && (
        <div className="blog-card-image">
          <img src={post.thumbnail} alt={post.title} loading="lazy" onError={() => setImageFailed(true)} />
          {featured && <span className="featured-badge">Most Loved</span>}
        </div>
      )}

      <div className="blog-card-content">
        <div className="blog-card-meta">
          {date && <time dateTime={date.iso}>{date.display}</time>}
          {mins && <><span className="meta-separator">•</span><span>{mins} min read</span></>}
          {post.views > 0 && <><span className="meta-separator">•</span><span>{post.views.toLocaleString()} views</span></>}
        </div>

        <h3 className="blog-card-title">{post.title}</h3>
        {post.excerpt && <p className="blog-card-excerpt">{post.excerpt}</p>}

        {post.tags && post.tags.length > 0 && (
          <div className="blog-card-tags">
            {post.tags.slice(0, 2).map(tag => (
              <span key={tag} className="tag">{tag}</span>
            ))}
          </div>
        )}

        <div className="blog-card-footer">
          <span className="read-more">Read Article →</span>
          <div className="blog-card-stats">
            {post.likes > 0 && <span className="likes">♥ {post.likes}</span>}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
